import React, { useState } from "react";
import { toast } from "react-toastify";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { Container, Form, ErrorMessage } from "./NotificationsStyles";
import { postNotification } from "../../services/notificationService";

const Notifications: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const handleNotification = async (e: React.FormEvent) => {
    e.preventDefault();

    if (title.length < 10) {
      toast.warn("O título deve ter no mínimo 10 caracteres.");
      setError("Ajuste o tamanho do título/mensagem");
      return;
    }
    if (message.length < 50) {
      toast.warn("A mensagem deve ter no mínimo 50 caracteres.");
      setError("Ajuste o tamanho do título/mensagem");
      return;
    }

    setError("");
    setLoading(true);
    try {
      await postNotification(title, message);
      toast.success("Notificação enviada com sucesso!");
    } catch (err) {
      // setError("Não foi possível autenticar. Verifique suas credenciais.");
      toast.error("Erro ao enviar notificação");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Form
        onSubmit={handleNotification}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h3>Envio de notificação</h3>
        <Input
          type="text"
          label="Título (10 - 50 caractéres)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          maxLength={50}
        />
        <Input
          type="text"
          label="Mensagem (50 - 100 caractéres)"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          maxLength={100}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <Button
          title="Enviar"
          onClick={(e) => handleNotification(e)}
          style={{ marginTop: "10vh" }}
          loading={loading}
        />
      </Form>
    </Container>
  );
};

export default Notifications;
